import { EditableValue } from './EditableValue';
import { ACCENT, FONT_MONO, MUTED } from '../../tokens';

interface SliderRowProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  format: (value: number) => string;
  parse?: (text: string) => number;
  onChange: (value: number) => void;
}

/** A labelled range slider whose value can also be typed directly. */
export function SliderRow({ label, value, min, max, step = 1, format, parse, onChange }: SliderRowProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        userSelect: 'none',
        WebkitUserSelect: 'none',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span
            style={{
              fontFamily: FONT_MONO,
              fontSize: '0.68rem',
              color: MUTED,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            {label}
          </span>
          <span style={{ fontFamily: FONT_MONO, fontSize: '0.58rem', color: '#555', letterSpacing: '0.04em' }}>
            Type to edit →
          </span>
        </div>

        <EditableValue value={value} format={format} parse={parse} onChange={onChange} min={min} max={max} />
      </div>

      <input
        type="range"
        aria-label={label}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        style={{ width: '100%', accentColor: ACCENT, cursor: 'pointer' }}
      />

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span style={{ fontFamily: FONT_MONO, fontSize: '0.6rem', color: '#333' }}>{format(min)}</span>
        <span style={{ fontFamily: FONT_MONO, fontSize: '0.6rem', color: '#333' }}>{format(max)}</span>
      </div>
    </div>
  );
}
